import { request } from "./api";
import type { PacienteAuthMeResponse, Paciente, User } from "./types";

// Re-export types
export type { PacienteAuthMeResponse, Paciente, User };

// GET /api/Auth/me/paciente
export async function getPacienteAuthMe(): Promise<PacienteAuthMeResponse> {
  const token = localStorage.getItem("accessToken");
  
  if (!token) {
    throw new Error("No hay token de acceso. Por favor, inicie sesión nuevamente.");
  }

  // La llamada a request ya maneja los errores HTTP (404, 400, etc.)
  // Si falla con 404, el error se propagará correctamente
  const result = await request<PacienteAuthMeResponse>("/Auth/me/paciente");

  if (!result?.user || !result?.paciente) {
    throw new Error("Perfil de paciente no encontrado");
  }

  return result;
}
